(() => {
  'use strict';
  const normalize = value => String(value || '').normalize('NFKD').toLowerCase().replace(/[®™]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const initialize = root => {
    if (root.dataset.lplCoaBound === 'true') return;
    const form = root.querySelector('[data-lpl-coa-search]');
    const input = root.querySelector('[data-lpl-coa-query]');
    const results = root.querySelector('[data-lpl-coa-results]');
    const table = root.querySelector('[data-lpl-coa-table]');
    const empty = root.querySelector('[data-lpl-coa-empty]');
    const status = root.querySelector('[data-lpl-coa-status]');
    if (!form || !input || !results || !table || !empty || !status) return;
    root.dataset.lplCoaBound = 'true';
    const rows = Array.from(root.querySelectorAll('[data-lpl-coa-record]'));
    const update = (value, moveToResults) => {
      const terms = normalize(value).split(' ').filter(Boolean);
      if (!terms.length) {
        results.hidden = true;
        table.hidden = true;
        empty.hidden = true;
        status.textContent = '';
        rows.forEach(row => { row.hidden = true; });
        return;
      }
      results.hidden = false;
      let matches = 0;
      let published = 0;
      rows.forEach(row => {
        const search = normalize(row.dataset.search);
        const matchesQuery = terms.every(term => search.includes(term));
        row.hidden = !matchesQuery;
        if (matchesQuery) {
          matches += 1;
          if (row.dataset.published === 'true') published += 1;
        }
      });
      table.hidden = matches === 0;
      empty.hidden = matches !== 0;
      const pending = matches - published;
      status.textContent = matches === 0 ? 'No matching published records.' : `${published} published ${published === 1 ? 'record' : 'records'}${pending ? ` · ${pending} ${pending === 1 ? 'product has' : 'products have'} no published records yet` : ''}.`;
      if (moveToResults) {
        results.focus({ preventScroll: true });
        results.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      }
    };
    form.addEventListener('submit', event => {
      event.preventDefault();
      update(input.value, true);
    });
    const hideClearedResults = () => { if (!normalize(input.value)) update('', false); };
    input.addEventListener('input', hideClearedResults);
    input.addEventListener('search', hideClearedResults);
    form.addEventListener('reset', () => update('', false));
    const requested = new URLSearchParams(window.location.search).get('lot');
    if (requested !== null) input.value = requested;
    update(input.value, false);
  };
  document.querySelectorAll('[data-lpl-coa]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    if (event.target.matches('[data-lpl-coa]')) initialize(event.target);
    event.target.querySelectorAll('[data-lpl-coa]').forEach(initialize);
  });
})();
